import { useMemo } from "react"
import { dateFormat } from "shared/util"

import { IconButton, Stack, StackProps, Tooltip, Typography } from "@mui/material"
import { CloseIcon } from 'shared/icons'

import { ArticleResult } from "interface/article"

import { formatJournalDate } from "features/article/util"
import { ArticleSourceChip } from "features/article/components/articleSourceChip"
import { PublicationTypeChips } from "features/article/components/publicationTypeChips"
import { ArticleWordsChips } from "features/article/components/articleWordsChips"
import { useArticlePreview } from "features/article/preview/container"

type ArticlePreviewHeaderProps = {
	article: ArticleResult
	container: ReturnType<typeof useArticlePreview>
} & StackProps
export const ArticlePreviewHeader = ({
	article,
	container: {
		onClose
	},
	...others
}: ArticlePreviewHeaderProps) => {
	const journalDate = useMemo(
		() => formatJournalDate(article),
		[article]
	)
	return (
		<Stack {...others} direction='column' padding={1}>
			<Stack direction='row' spacing={1} justifyContent='flex-start' alignItems='flex-start'>
				<Stack direction='column' flexGrow={1}>
					<Stack direction='column' padding={1}>
						{article.titleJpn === null ? (
							<Typography variant='h5' component='div' translate='yes'>{article.title ?? '(No title)'}</Typography>
						) : article.titleJpn !== article.title ? (
							<>
								<Typography variant='h5' component='div'>{article.titleJpn}</Typography>
								<Typography variant='body2' color='text.secondary' component='div'>{article.title}</Typography>
							</>
						) : (
							<Typography variant='h5' component='div'>{article.titleJpn}</Typography>
						)}
					</Stack>
				</Stack>

				{onClose && (
					<Tooltip title='閉じる'><IconButton onClick={onClose}><CloseIcon/></IconButton></Tooltip>
				)}
			</Stack>

			<Stack direction='row' justifyContent='flex-end' flexWrap="wrap">
				<Stack flexGrow={1} direction='row' spacing={0.5} flexWrap="wrap" useFlexGap>
					<ArticleSourceChip source={article.source} size='small'/>
					<PublicationTypeChips publicationTypes={article.publicationType} size='small'/>
					<ArticleWordsChips words={article.words} size='small'/>
				</Stack>

				{journalDate ? (
					<Stack direction='row' spacing={1} alignItems='center'>
						<Typography variant='caption' color='text.secondary' component='span'>発行</Typography>
						<Typography variant='body2' color='text.primary' component='span'>{journalDate}</Typography>

						{article.completedDate || article.revicedDate ? (
							<>
								<Typography variant='caption' color='text.secondary' component='span'>(</Typography>

								{article.completedDate ? (
									<Stack direction='row' spacing={1} alignItems='center'>
										<Typography variant='caption' color='text.secondary' component='span'>作成</Typography>
										<Typography variant='body2' color='text.primary' component='span'>{dateFormat(article.completedDate, { nullText: '--', wareki: false })}</Typography>
									</Stack>
								) : <></>}

								{article.revicedDate ? (
									<Stack direction='row' spacing={1} alignItems='center'>
										<Typography variant='caption' color='text.secondary' component='span'>更新</Typography>
										<Typography variant='body2' color='text.primary' component='span'>{dateFormat(article.revicedDate, { nullText: '--', wareki: false })}</Typography>
									</Stack>
								) : <></> }

								<Typography variant='caption' color='text.secondary' component='span'>)</Typography>
							</>
						) : <></>}
					</Stack>
				) : <></>}
			</Stack>
		</Stack>
	)
}